module.exports = __webpack_public_path__ + "img/brush-green.cfa18e3c.png";